import styled from 'styled-components';

const StandardDetailsCardsWrapper = styled.div`
  max-width: 100%;
`;

export default { StandardDetailsCardsWrapper };
